import { type FC, type MouseEvent, type ReactNode } from 'react';
import classnames from 'classnames';
// Import Styles
import styles from './FilterDependencyDots.module.scss';

interface DependencyPillProps {
    className?: string;
    children: ReactNode;
}

const stopPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

/**
 * Grey pill that groups the dependency dots tile and the info tile next to a filter/KPI name.
 * Swallows clicks so hovering/clicking the icons does not trigger the owning row's action.
 */
const DependencyPill: FC<DependencyPillProps> = ({ className, children }) => (
    <div className={classnames(styles.dependencyDotsPill, className)} onClick={stopPropagation} role="presentation">
        {children}
    </div>
);

export default DependencyPill;
